module.exports = __webpack_public_path__ + "img/icon_instagram.735238e1.png";